import React, { Suspense, useContext, useEffect } from 'react'
import { LayoutProvider } from './component/layout/context/layoutcontext'
import Layout from './component/layout/Layout'
import { RdmsMenuContext } from './component/menu/context/rdmsMenuContext'
import { matchPath, useLocation, useNavigate } from 'react-router-dom'
import ErrorBoundary from './component/common/ErrorBoundary'
import { I18nextProvider } from 'react-i18next'
import i18n from '../src/locales/i18n' // i18next 설정 파일
import { getBrand } from './utils/tenant'

function App() {
    const location = useLocation()
    const navigate = useNavigate()
    const path = location.pathname
    const match = matchPath
    const { lazyComponents, findSidebarMenus } = useContext(RdmsMenuContext)
    const brand = getBrand()
    const fileterComponent = lazyComponents.filter(({ to }) => {
        return match({ path: to }, path)
    })

    let Component

    if (lazyComponents && fileterComponent.length > 0) {
        Component = lazyComponents.length !== 0 ? fileterComponent[0]['component'] : null
    }

    useEffect(() => {
        if (path !== '/' && lazyComponents.length > 0 && fileterComponent.length === 0) {
            navigate('/notfound', { state: { error: { message: '' } } })
        }
    }, [path, fileterComponent, lazyComponents, navigate])

    useEffect(() => {
        findSidebarMenus()
    }, [findSidebarMenus])

    return (
        <I18nextProvider i18n={i18n}>
            {' '}
            {/* I18nextProvider로 App 감싸기 */}
            <LayoutProvider>
                <Layout>
                    <ErrorBoundary>
                        <Suspense fallback={<div>Loading pages..</div>}>
                            {Component ? (
                                <Component />
                            ) : (
                                <div className="flex justify-content-evenly align-items-center pt-3" style={{ height: '70vh' }}>
                                    <div className="mx-1" style={{ width: '100%', textAlign: 'center' }}>
                                        {brand.logoImg ? (
                                            <img src={brand.logoImg} alt={"logo"} style={{ width: '40%' }} />
                                        ) : (
                                            <span style={{ fontSize: '40px', fontWeight: 700, color: '#1a1a1a' }}>{brand.logoText}</span>
                                        )}
                                    </div>
                                </div>
                            )}
                        </Suspense>
                    </ErrorBoundary>
                </Layout>
            </LayoutProvider>
        </I18nextProvider>
    )
}
export default App
